import { antecedentActionTypes } from '../constants/ApiConstants';

const initialState = {
  masterData: null,
  antecedentList: null,
  antecedentDetail: null,
  saved_antecedent: null,
  deleted_antecedent: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case antecedentActionTypes.get_masterData.REQUEST:
      return {
        ...state,
        loading: true,
        masterData: null,
      };
    case antecedentActionTypes.get_masterData.SUCCESS:
      return {
        ...state,
        loading: false,
        masterData: payload,
      };
  case antecedentActionTypes.save_antecedent.REQUEST:
    return {
      ...state,
      loading: true,
      saved_antecedent: null,
    };
  case antecedentActionTypes.save_antecedent.SUCCESS:
    return {
      ...state,
      loading: false,
      saved_antecedent: payload,
    };
  case antecedentActionTypes.get_antecedentList.REQUEST:
    return {
      ...state,
      loading: true,
      antecedentList: null,
    };
  case antecedentActionTypes.get_antecedentList.SUCCESS:
    return {
      ...state,
      loading: false,
      antecedentList: payload,
    };
  case antecedentActionTypes.get_antecedentDetail.REQUEST:
    return {
      ...state,
      loading: true,
      antecedentDetail: null,
    };
  case antecedentActionTypes.get_antecedentDetail.SUCCESS:
    return {
      ...state,
      loading: false,
      antecedentDetail: payload,
    };
  case antecedentActionTypes.delete_antecedent.REQUEST:
    return {
      ...state,
      loading: true,
      deleted_antecedent: null,
    };
  case antecedentActionTypes.delete_antecedent.SUCCESS:
    return {
      ...state,
      loading: false,
      deleted_antecedent: payload,
    };
  default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/BehaviorReductiom/Antecedents/reducers/antecedentsReducer.js